import { render, staticRenderFns } from "./JoinRequestsModal.vue?vue&type=template&id=2ccb26ea&scoped=true"
import script from "./JoinRequestsModal.vue?vue&type=script&lang=js"
export * from "./JoinRequestsModal.vue?vue&type=script&lang=js"
import style0 from "./JoinRequestsModal.vue?vue&type=style&index=0&id=2ccb26ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb26ea",
  null
  
)

export default component.exports